<template>
  <v-card>
    <v-card-title class="title">Dashboard</v-card-title>
    <v-card-text>
      <v-form ref="form">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="name"
              placeholder="Name"
              :rules="nameRules"
              autocomplete="off"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="layout"
              :items="layouts"
              label="Layout"
              :rules="layoutRules"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="mt-4">
          <v-col md="6" cols="12">
            <v-select
              v-model="chart1"
              :items="chartEntries"
              label="Gráfica 1"
              v-if="totalCharts >= 1"
              :rules="chartRules"
              required
            ></v-select>
          </v-col>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart2"
              :items="chartEntries"
              label="Gráfica 2"
              v-if="totalCharts >= 2"
              :rules="chartRules"
              required
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart3"
              :items="chartEntries"
              label="Gráfica 3"
              v-if="totalCharts >= 3"
              :rules="chartRules"
              required
              dense
            ></v-select>
          </v-col>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart4"
              :items="chartEntries"
              label="Gráfica 4"
              v-if="totalCharts >= 4"
              :rules="chartRules"
              required
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart5"
              :items="chartEntries"
              label="Gráfica 5"
              v-if="totalCharts >= 5"
              :rules="chartRules"
              required
              dense
            ></v-select>
          </v-col>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart6"
              :items="chartEntries"
              label="Gráfica 6"
              v-if="totalCharts >= 6"
              :rules="chartRules"
              required
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart7"
              :items="chartEntries"
              label="Gráfica 7"
              v-if="totalCharts >= 7"
              :rules="chartRules"
              required
              dense
            ></v-select>
          </v-col>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart8"
              :items="chartEntries"
              label="Gráfica 8"
              v-if="totalCharts >= 8"
              :rules="chartRules"
              required
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6" cols="12">
            <v-select
              v-model="chart9"
              :items="chartEntries"
              label="Gráfica 9"
              v-if="totalCharts >= 9"
              :rules="chartRules"
              required
              dense
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" class="text-capitalize" @click.prevent="saverOrUpdate">
              <v-icon size="20">mdi-content-save</v-icon>Guardar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  data() {
    return {
      name: "",
      layout: "",
      layouts: [
        { value: "3top", text: "3 gráficas" },
        { value: "3rows", text: "3 gráficas en columna" },
        { value: "4", text: "4 gráficas" },
        { value: "5", text: "5 gráficas" },
        { value: "6", text: "6 gráficas" },
        { value: "8", text: "8 gráficas" },
      ],
      charts: [],
      chart1: "",
      chart2: "",
      chart3: "",
      chart4: "",
      chart5: "",
      chart6: "",
      chart7: "",
      chart8: "",
      chart9: "",
      chart10: "",
      chartEntries: [
        { value: "results", text: "Resultados" },
        { value: "categories", text: "Categorias" },
        { value: "entities", text: "Entidades" },
        { value: "polarities", text: "Polaridad" },
        { value: "wordcloud", text: "WordCloud" },
        { value: "authors", text: "Autores" },
        { value: "authors_categories", text: "Autores vs Categoría" },
        { value: "cities_categories", text: "Ciudades vs Categoría" },
        { value: "states_categories", text: "Departamento vs Categoría" },
        { value: "sources", text: "Fuentes" },
        //{ value: "vectorMap", text: "Mapa Político" },
        { value: "googleMapMarkers", text: "Mapa de Eventos" },
        // { value: "googleMapBubbles", text: "Mapa Demográfico" },
        { value: "googleMapHeat", text: "Mapa de Calor" },
        { value: "vectorMapWorld", text: "Mapa Coroplético Mundial" },
        { value: "vectorMapColombia", text: "Mapa Coroplético Colombia" },
        { value: "categories_polarity", text: "Categorias vs Polaridad" },
        { value: "entities_link", text: "Análisis Link" },
        { value: "entities_polarity", text: "Entidades vs Polaridad" },
        { value: "entities_categories", text: "Entidades vs Categorias" },
        { value: "authors_activity", text: "Actividad Autores" },
        { value: "cities_activity", text: "Actividad Ciudades" },
        { value: "states_activity", text: "Actividad Departamentos" },
        // { value: "authors_activity_percentage", text: "Actividad Autores Porcentual",},
        { value: "entities_activity", text: "Actividad Entidades" },
        { value: "category_activity", text: "Actividad Categorias" },
        // { value: "category_activity_percentage", text: "Actividad Categorias Porcentual"},
        { value: "polarity_activity", text: "Actividad Polaridad" },
        // { value: "polarity_activity_percentage", text: "Actividad Polaridad Porcentual",},
      ],
      nameRules: [
        (v) => !!v || "El nombre es requerido",
        (v) =>
          (v && v.length >= 5) ||
          "El nombre debe contener al menos 5 carácteres",
      ],
      layoutRules: [(v) => !!v || "El layout es requerido"],
      chartRules: [(v) => !!v || "Debe seleccionar un elemento"],
    };
  },
  mounted() {
    if (this.editDashboard) {
      this.$http
        .get(`/api/dashboards/${this.$route.params.dashboardId}`)
        .then((response) => {
          this.name = response.data.dashboard.name;
          this.layout = response.data.dashboard.definition.layout;
          this.charts = response.data.dashboard.definition.charts;
          response.data.dashboard.definition.charts.forEach(
            (chart, index) => {
              this[`chart${index + 1}`] = chart;
            }
          );
        });
    }
  },
  methods: {
    saverOrUpdate() {
      if (this.$refs.form.validate()) {
        let charts = [];
        if (this.chart1) {
          charts.push(this.chart1);
        }
        if (this.chart2) {
          charts.push(this.chart2);
        }
        if (this.chart3) {
          charts.push(this.chart3);
        }
        if (this.chart4) {
          charts.push(this.chart4);
        }
        if (this.chart5) {
          charts.push(this.chart5);
        }
        if (this.chart6) {
          charts.push(this.chart6);
        }
        if (this.chart7) {
          charts.push(this.chart7);
        }
        if (this.chart8) {
          charts.push(this.chart8);
        }
        if (this.chart9) {
          charts.push(this.chart9);
        }

        let dashboard = {
          name: this.name,
          definition: {
            layout: this.layout,
            charts: charts,
          },
        };

        if (this.editDashboard) {
          this.$http
            .put(`/api/dashboards/${this.$route.params.dashboardId}`, dashboard)
            .then((response) => {
              console.log(response);
              this.$router.push({ path: "/dashboards" });
            });
        } else {
          this.$http.post(`/api/dashboards`, dashboard).then((response) => {
            console.log(response);
            this.$router.push({ path: "/dashboards" });
          });
        }
      }
    },
  },
  computed: {
    editDashboard() {
      return !!this.$route.params.dashboardId;
    },
    totalCharts() {
      switch (this.layout) {
        case "3top":
        case "3rows":
          return 3;
        case "4":
          return 4;
        case "5":
          return 5;
        case "6":
          return 6;
        case "8":
          return 8;
        default:
          return 0;
      }
    },
  },
};
</script>

<style>
</style>